export default "__VITE_PUBLIC_ASSET__5a52f9db__"